/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface MoreCircleProps {
    color?: string
    size?: string
    className?: string
}

const MoreCircle = (props: MoreCircleProps) => {
    const { className = '', color = '#364152' } = props
    return (
        <span className={'flex items-center justify-center' + className}>
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.49992 14.6667C12.1666 14.6667 15.1666 11.6667 15.1666 8.00001C15.1666 4.33334 12.1666 1.33334 8.49992 1.33334C4.83325 1.33334 1.83325 4.33334 1.83325 8.00001C1.83325 11.6667 4.83325 14.6667 8.49992 14.6667Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.1644 7.99999H11.1704" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.49691 7.99999H8.5029" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.82967 7.99999H5.83566" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
    )
}

export default MoreCircle
